module.exports = __webpack_public_path__ + "static/media/setup_active.93783bbc.svg";